// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2C8mU","header":"PatientBlock_header__2qhLN","label":"PatientBlock_label__10JTS","option":"PatientBlock_option__GoywJ"};